import React from 'react';
import './CTALink.css';

// Hand-drawn underline SVG from Figma
const underlineIcon = "/assets/figma/8dbc3099431a81a908d397126113c040d17af44d.svg";

interface CTALinkProps {
  text: string;
  onClick?: () => void;
  href?: string;
  type?: 'primary' | 'secondary';
  color?: 'awasi' | 'off-white' | 'white';
  className?: string;
}

export const CTALink: React.FC<CTALinkProps> = ({
  text,
  onClick,
  href,
  type = 'secondary',
  color = 'awasi',
  className = ''
}) => {
  const handleClick = (e: React.MouseEvent) => {
    if (onClick) {
      if (!href) {
        e.preventDefault();
      }
      onClick();
    }
  };

  const Element = href ? 'a' : 'button';
  const elementProps = href 
    ? { href, onClick: handleClick }
    : { type: 'button' as const, onClick: handleClick };

  return (
    <Element
      {...elementProps}
      className={`cta-link cta-link--${type} cta-link--${color} ${className}`}
    >
      <span className="cta-link__text">{text}</span>
      <img src={underlineIcon} alt="underline" className="cta-link__underline" />
    </Element>
  );
};